import { computed, type ComputedRef } from 'vue';
import { normalizeNumber, removeUnnecessaryCharsFromNumber } from '@/utils/numberUtils';
import type { ContactExtended } from '@/data/contacts/Contact';

export const useGetContactByNumber = (contacts?: ComputedRef<ContactExtended[]>) => {
  const normalizedContactByExtensions = computed(() => {
    if (!contacts?.value) return {};
    return contacts.value.reduce(
      (acc, contact) => {
        const extension = contact.extension;
        if (extension) {
          const sanitizedExtension = removeUnnecessaryCharsFromNumber(extension);
          acc[sanitizedExtension] = contact;
        }

        return acc;
      },
      {} as Record<string, ContactExtended>
    );
  });

  const normalizedContactByPhoneNumber = computed(() => {
    if (!contacts?.value) return {};
    return contacts?.value.reduce(
      (acc, contact) => {
        const number = normalizeNumber(contact.phoneNumber);
        if (number) {
          acc[number] = contact;
        }
        return acc;
      },
      {} as Record<string, ContactExtended>
    );
  });

  const getContactByPhoneNumber = (callNumber: string): ContactExtended | undefined => {
    const sanitizedCallNumber = removeUnnecessaryCharsFromNumber(callNumber);
    const normalizedPhoneNumber = normalizeNumber(callNumber);

    if (normalizedPhoneNumber == null) {
      return undefined;
    }

    return normalizedContactByExtensions.value[sanitizedCallNumber] || normalizedContactByPhoneNumber.value[normalizedPhoneNumber];
  };

  return { getContactByPhoneNumber };
};
